// @ts-nocheck
import {Provider} from '@angular/core';
import {NG_DOC_CONTEXT} from '@ng-doc/app/tokens';

export const ngDocContextProvider: Provider = {
	provide: NG_DOC_CONTEXT,
	useValue: {
		navigation: [
			
			{
				title: 'Getting Started',
				route: '/getting-started',
				expandable: true,
				expanded: true,
				order: 1,
				hidden: false,
				children: [
					
			{
				title: 'What is',
				route: '/getting-started/what-is',
				order: 1,
				hidden: false,
			},
					
			{
				title: 'Peer dependency',
				route: '/getting-started/peer-dependency',
				order: 2,
				hidden: false,
			},
					
			{
				title: 'Install',
				route: '/getting-started/install',
				order: 3,
				hidden: false,
			},
					
			{
				title: 'Usage',
				route: '/getting-started/usage',
				order: 4,
				hidden: false,
			},
					
			{
				title: 'Docs',
				route: '/getting-started/docs',
				order: 5,
				hidden: false,
			},
					
			{
				title: 'Migration',
				route: '/getting-started/migration',
				order: 6,
				hidden: false,
			},
				]
			},
			
			{
				title: 'M-theme',
				route: '/m-theme',
				expandable: true,
				expanded: false,
				order: 2,
				hidden: false,
				children: [
					
			{
				title: 'Colors',
				route: '/m-theme/theming',
			},
				]
			},
			
			{
				title: 'M-ui',
				route: '/m-ui',
				expandable: true,
				expanded: false,
				order: 3,
				hidden: false,
				children: [
					
			{
				title: 'M-affluence',
				route: '/m-ui/m-affluence',
			},
					
			{
				title: 'M-app-download',
				route: '/m-ui/m-app-download',
			},
					
			{
				title: 'M-disturbance-display',
				route: '/m-ui/m-disturbance-display',
			},
					
			{
				title: 'M-icons',
				route: '/m-ui/m-icons',
			},
					
			{
				title: 'M-list-wrapper',
				route: '/m-ui/m-list-wrapper',
			},
					
			{
				title: 'M-logo-lines',
				route: '/m-ui/m-logo-lines',
			},
					
			{
				title: 'M-scroll',
				route: '/m-ui/m-scroll',
			},
					
			{
				title: 'M-table',
				route: '/m-ui/m-table',
			},
				]
			},
			
			{
				title: 'Angular-materiel',
				route: '/angular-materiel',
				expandable: true,
				expanded: false,
				order: 4,
				hidden: false,
				children: [
					
			{
				title: 'Autocomplete',
				route: '/angular-materiel/material-autocomplete',
			},
					
			{
				title: 'Badge',
				route: '/angular-materiel/material-badge',
			},
					
			{
				title: 'Bottom-sheet',
				route: '/angular-materiel/material-bottom-sheet',
			},
					
			{
				title: 'Button',
				route: '/angular-materiel/material-button',
			},
					
			{
				title: 'Button-toggle',
				route: '/angular-materiel/material-button-toggle',
			},
					
			{
				title: 'Card',
				route: '/angular-materiel/material-card',
			},
					
			{
				title: 'Checkbox',
				route: '/angular-materiel/material-checkbox',
			},
					
			{
				title: 'Chips',
				route: '/angular-materiel/material-chips',
			},
					
			{
				title: 'Datepicker',
				route: '/angular-materiel/material-datepicker',
			},
					
			{
				title: 'Dialog',
				route: '/angular-materiel/material-dialog',
			},
					
			{
				title: 'Divider',
				route: '/angular-materiel/material-divider',
			},
					
			{
				title: 'Expansion Panel',
				route: '/angular-materiel/material-expansion-panel',
			},
					
			{
				title: 'Form field',
				route: '/angular-materiel/material-form-field',
			},
					
			{
				title: 'Input',
				route: '/angular-materiel/material-input',
			},
					
			{
				title: 'List',
				route: '/angular-materiel/material-list',
			},
					
			{
				title: 'Progress bar',
				route: '/angular-materiel/material-progress-bar',
			},
					
			{
				title: 'Progress spinner',
				route: '/angular-materiel/material-progress-spinner',
			},
					
			{
				title: 'Radio',
				route: '/angular-materiel/material-radio',
			},
					
			{
				title: 'Ripples',
				route: '/angular-materiel/material-ripples',
			},
					
			{
				title: 'Select',
				route: '/angular-materiel/material-select',
			},
					
			{
				title: 'Sidenav',
				route: '/angular-materiel/material-sidenav',
			},
					
			{
				title: 'Slide toggle',
				route: '/angular-materiel/material-slide-toggle',
			},
					
			{
				title: 'Slider',
				route: '/angular-materiel/material-slider',
			},
					
			{
				title: 'Snackbar',
				route: '/angular-materiel/material-snackbar',
			},
					
			{
				title: 'Sort header',
				route: '/angular-materiel/material-sort-header',
			},
					
			{
				title: 'Stepper',
				route: '/angular-materiel/material-stepper',
			},
					
			{
				title: 'Table',
				route: '/angular-materiel/material-table',
			},
					
			{
				title: 'Tabs',
				route: '/angular-materiel/material-tabs',
			},
					
			{
				title: 'Toolbar',
				route: '/angular-materiel/material-toolbar',
			},
					
			{
				title: 'Tooltip',
				route: '/angular-materiel/material-tooltip',
			},
					
			{
				title: 'Tree',
				route: '/angular-materiel/material-tree',
			},
				]
			},
			
			{
				title: 'API',
				route: '/api',
			},
			
			{
				title: 'Others',
				route: '/others',
				expandable: true,
				expanded: false,
			},
		],
	}
}
